import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationOidcService } from '../../services/authentication-oidc-service';
import { environment } from '../../../environments/environment';
import { FromProviderType } from '../../interfaces/from-type-enum';

@Component({
  selector: 'app-login-callback',
  templateUrl: './login-callback.html',
  styleUrls: ['./login-callback.scss'],
})
export class LoginCallbackComponent implements OnInit {
  constructor(
    private authenticationOidcService: AuthenticationOidcService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const fromProviderType = sessionStorage.getItem(environment.PROVIDER_TYPE_STORAGE_KEY);
      if (!fromProviderType) {
        this.router.navigate(['/unauthorized']);
        return;
      }
      await this.authenticationOidcService.login(fromProviderType as FromProviderType);
      if (this.authenticationOidcService.isLoggedIn) {
        this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
          window.location.reload();
        });
      } else {
        this.router.navigate(['/unauthorized']);
      }
    } catch (error) {
      this.router.navigate(['/unauthorized']);
    }
  }
}
